<template>
  <div
    class="relative mb-4 divide-y divide-gray-200 rounded-5 border border-gray-300 bg-white"
    data-cy="block-card"
  >
    <div
      class="group flex items-center justify-between px-4 py-2"
      @click="toggleCollapsed"
    >
      <div class="flex items-center space-x-2">
        <div
          class="drag-handle mr-1 flex cursor-grab items-center justify-center active:cursor-grabbing"
          data-cy="card-drag-handle"
          @click.stop
        >
          <icon-base
            class="h-3 w-2 text-gray-400"
            height="12"
            width="7"
            :icon="IconDragHandle"
            viewBox="0 0 12 20"
          />
        </div>
        <span class="text-sm font-medium text-gray-700">
          {{ title }}
        </span>
      </div>

      <div class="flex items-center space-x-2">
        <button
          v-if="showDelete && !disabled"
          class="p-1 text-gray-500 hover:text-gray-600"
          data-cy="delete-card-button"
          @click.stop="$emit('delete')"
        >
          <icon-base :icon="IconTrashCanOutline" class="h-4 w-4" />
        </button>
        <div
          class="p-1 text-gray-500 hover:text-gray-700"
          data-cy="toggle-card-collapse"
        >
          <icon-chevron-down
            class="transform transition-transform"
            :class="{ 'rotate-180': !isCollapsed }"
          />
        </div>
      </div>
    </div>

    <div v-if="!isCollapsed" class="p-4">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import IconDragHandle from "@/components/icons/IconDragHandle.vue";
import IconTrashCanOutline from "@/components/icons/IconTrashCanOutline.vue";
import IconChevronDown from "@/components/icons/deals/IconChevronDown.vue";
import IconBase from "@/components/ui/IconBase.vue";

const { showDelete = false, disabled = false } = defineProps<{
  title: string;
  showDelete?: boolean;
  disabled?: boolean;
}>();

defineEmits<{
  delete: [];
}>();

const isCollapsed = ref(false);

const toggleCollapsed = () => {
  isCollapsed.value = !isCollapsed.value;
};
</script>
